import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-lead',
  imports: [SharedModule],
  templateUrl: './delete-lead.component.html',
  styleUrl: './delete-lead.component.scss'
})
export class DeleteLeadComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() editLeadData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api : LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete(){
    this.isLoading = true;

    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      lead_id: this.editLeadData.lead_id
    }

    this.api.deleteLead(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Lead deleted successfully'});
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Something went wrong'});
        this.isLoading = false;
      }
    }
    );

  }

}
